import { Form } from 'react-bootstrap';

const TextPassword = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
}) => (
  <div className={className}>
    {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
    <div>
      <Form.Control
        name={name}
        type="password"
        // id="input"
        value={value}
        className={inputClassName}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  </div>
);

export default TextPassword;
